package com.macrofocus.eflux.network

import com.macrofocus.eflux.diagram.DiagramType
import com.macrofocus.eflux.network.logical.LogicalBranchId
import com.macrofocus.eflux.network.logical.LogicalBusId
import com.macrofocus.eflux.network.logical.LogicalNetwork
import com.macrofocus.eflux.network.logical.logicalBusIdOf
import korlibs.time.DateTime

class LogicalEFluxNetwork(
    override val logical: LogicalNetwork,
    override val graphical: GraphicalNetwork,
    dateTime: DateTime,
    diagramType: DiagramType
) : AbstractEFluxNetwork(graphical) {
    override val graphicalLinks : Map<LogicalBranchId, EFluxLink>
    override val graphicalNodes : Map<LogicalBusId, EFluxNode>

    init {
//        val logicalNodes : Map<LogicalBusId, EFluxNode?> = logical.nodes
//            .associateWith {
//                val point = graphical.points[it.id]
//                if(point != null) {
//                    EFluxNode(it, point)
//                } else {
//                    null
//                }
//            }
//            .filter{ it.value != null }
//            .mapKeys { it.key.id }

        graphicalNodes = graphical.nodes
            .associateWith {
                val bus = logical.logicalNodes[it.id]
                EFluxNode(bus, it, dateTime)
            }
            .mapKeys { it.key.id }

        val nodes = graphicalNodes

        nodes.forEach { addNode(it.value) }

        println("Adding " + nodes.size + " logical nodes")

//        val logicalLinks : Map<CombinedBranches, EFluxLink?> = logical.links
//            .associateWith {
//                val id = it.logicalBranchId
//                val paths = graphical.paths.get(id)
//
//                if(paths != null) {
////                    println("Info: Found logical branch " + pair + " -> " + paths)
//                    EFluxLink(it, paths)
//                } else {
////                    println("Error: could not find logical branch " + pair)
//                    null
//                }
//            }
//            .also {
//                val missing = logical.links.toList().size - it.filter { it.value != null }.size
//                if(missing > 0) {
//                    println("" + missing + " links are missing in graphical map")
//                }
//            }
//            .filter{ it.value != null }

        graphicalLinks = graphical.links
            .associateWith {
                val id = it.logicalBranchId
                val link = logical.logicalLinks.get(id)

                EFluxLink(link, it, dateTime, diagramType)
            }
            .mapKeys { it.key.logicalBranchId }
//            .also {
//                val missing = logical.links.toList().size - it.filter { it.value != null }.size
//                if(missing > 0) {
//                    println("" + missing + " links are missing in graphical map")
//                }
//            }

        val links = graphicalLinks

        println("Adding " + links.size + " logical links")
        links.forEach {
            val link = it.value
            val from = nodes[it.key.from]
            val to = nodes[it.key.to]
            if(from != null && to != null) {
                addUndirectedEdge(
                    EFluxNode(from.bus, from.point, dateTime),
                    EFluxNode(to.bus, to.point, dateTime),
                    link
                )
            } else {
                // Special case for line from Bassecourt
                if(from != null && it.key.name == "SBASSE2-SMUEH32-1") {
                    val smuehb2 = nodes[logicalBusIdOf("SMUEHB2")]
                    if(smuehb2 != null) {
                        addUndirectedEdge(
                            EFluxNode(from.bus, from.point, dateTime),
                            EFluxNode(smuehb2.bus, smuehb2.point, dateTime),
                            link
                        )
                    } else {
                        println("Could not find " + it.key.from + " to " + it.key.to + "(" + link + ")")
                    }
                } else {
                    println("Could not find " + it.key.from + " to " + it.key.to + "(" + link + ")")
                }
            }
        }
    }
}